import { defineVersions } from '../../helpers/define-versions';

export const TEXT_VERSIONS = defineVersions({
  component: 'Text',
  current: '2.2',
  previous: '2.1',
  // Unversioned call sites keep rendering the old version until you deliberately flip this.
  default: '2.1',
});
